import Vue from "vue";
import Component from "vue-class-component";

@Component
export class ConsentUrl extends Vue {
  get $m_consentUrl() {
    return this.$i18n.locale === "en"
      ? this.$constant.PDF_CONSENT_EN
      : this.$constant.PDF_CONSENT_BM;
  }

  get $m_replacedConsentLink() {
    return (this.$t("forms.parent-consent") as string).replace(
      "u@",
      this.$m_consentUrl
    );
  }
}
